export default __webpack_public_path__ + "static/media/decada-2010-0009-min.c167723e.jpg";